export const caseStudies = {
  caseStudiesHero: {
    subtitle: 'CASE STUDIES',
    title: '導入事例',
  },
  empowerment: {
    title: 'EMPOWERMENT CODE ACADEMY',
    titleKana: 'エンパワメントコードアカデミー',
    subtitle: '優しさを、折れない強さへ。構造がもたらす真の自立',
    concept: 'コンセプト',
    conceptText: '多くの女性が「変わりたい」と願いながら足踏みしてしまう理由は、意志の弱さではありません。それは、幼少期から無意識に刷り込まれた「認知の構造」にあります。',
    description1: 'EMPOWERMENT CODE ACADEMYは、精神論や一時的な高揚ではなく、脳科学と行動心理学の視点から、女性特有の思考パターンを解き明かし、再設計する教育機関です。',
    description2: '私たちは、女性が本来持つ「慈愛」を損なうことなく、それを社会を動かす「しなやかな強さ」へと昇華させる独自のフレームワークを提示します。感情の波に呑まれる主役ではなく、自らの人生の「構造（CODE）」を自在に操る設計者へ。日本から世界へ、真の自律と調和をもたらす新たな教育のスタンダードが、ここから始まります。',
    button: 'このプログラムの詳細を照会する',
  },
  quantum: {
    title: 'QUANTUM MEDICINE ACADEMY',
    titleKana: '量子医学アカデミー',
    subtitle: '心身の構造を科学し、生命のパフォーマンスを再定義する',
    description: '量子医学アカデミーは、神経科学・量子理論・行動心理学を統合し、人間の「思考・感情・身体」の相互作用を体系化。単なる知識の習得ではなく、脳の可塑性を利用した科学的訓練により、生存戦略（行動パターン）の根本的な再構築を目指す実践教育機関です。',
    professionalPath: {
      label: 'PROFESSIONAL PATH',
      title: '量子医学療法士学科',
      description: '臨床現場で即戦力となる「評価力」と「介入設計力」を養成。心身相関と自律神経調整の理論を基盤に、医療・対人支援の次世代スタンダードを構築します。',
    },
    selfOptimizationPath: {
      label: 'SELF-OPTIMIZATION PATH',
      title: 'ウェルネス学科',
      description: '自己調整力の極致へ。呼吸、姿勢、感情マネジメントを通じ、持続可能な高パフォーマンス状態を科学的に再現する技術を習得します。',
    },
    button: 'このプログラムの詳細を照会する',
  },
  corporate: {
    title: 'CORPORATE & SOCIAL SOLUTIONS',
    subtitle: '組織と社会に、再現可能な変革を',
    description: '企業研修から次世代教育支援、全国規模のセミナーまで。DREAM CODEの理論を、実社会での変革として証明します。',
    solutions: {
      training: {
        subtitle: 'Corporate Training',
        title: '企業研修',
        description: 'リーダーシップ開発、生産性向上のための構造設計プログラムを提供。',
      },
      nextGen: {
        subtitle: 'Next Generation',
        title: '次世代教育支援',
        description: '教育現場における「構造的思考」の普及と、志の高い若層の育成。',
      },
      seminars: {
        subtitle: 'National Seminars',
        title: 'ナショナルセミナー',
        description: '日本各地でのワークショップ開催を通じた、DREAM CODEの社会還元。',
      },
    },
    bottomMessage: 'これだけの実績が日本にあるからこそ、国際会議での受賞も必然である。理論と実践の融合が、真の変革を生み出します。',
  },
};